import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {InputComponent} from './input/input.component';
import {DateTimeComponent} from './date-time/date-time.component';
import {SelectComponent} from './select/select.component';
import {
  ControlContainer,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {CodeInputComponent} from "./code-input/code-input.component";

@NgModule({
  declarations: [InputComponent, DateTimeComponent, SelectComponent, CodeInputComponent],
  imports: [CommonModule, IonicModule, FormsModule, ReactiveFormsModule],
  exports: [
    InputComponent,
    DateTimeComponent,
    SelectComponent,
    CodeInputComponent,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class FormElementsModule {
}
